import '../css/style.scss'

(function () {

  const styleVariationToggle = () => {
    const DOM = {};

    var currentUrl = window.location.href;

    const handleVariation = (e) => {
      e.preventDefault();
      const styleVariation = e.currentTarget.getAttribute('data-file-name');
      if (!styleVariation) {
        console.error('No style variation provided');
        return;
      }

      // Set the cookie for style variation
      document.cookie = "style_variation=" + encodeURIComponent(styleVariation) + "; path=/;";

      // Reload the page without changing the URL
      window.location.reload();
    }

    const handleDefault = (e) => {
      e.preventDefault();

      // Delete the cookie
      document.cookie = "style_variation=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

      // Reload the page
      window.location.reload();
    }

    const cacheDOM = () => {
      DOM.variationToggler = document.querySelectorAll('.variation-switcher-style-switcher');
      DOM.resetButton = document.querySelector('.variation-switcher-style-switcher-default');
      DOM.gradientContainClass = document.querySelector('.has-gradient-1-gradient-background');
    }

    const eventListeners = () => {
      DOM.variationToggler.forEach(toggler => {
        toggler.addEventListener('click', handleVariation);
      });
      if (DOM.resetButton) {
        DOM.resetButton.addEventListener('click', handleDefault);
      }
    }

    // Utility function to get a cookie value by name
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    // Function to add the active class to the matching button or set default if no cookie is found
    const setActiveClass = () => {
      const styleVariation = decodeURIComponent(getCookie('style_variation') || '');
      let activeSet = false;

      if (styleVariation) {
        DOM.variationToggler.forEach(toggler => {
          if (toggler.getAttribute('data-file-name') === styleVariation) {
            toggler.classList.add('variation-switcher-style-switcher--active');
            activeSet = true;
          } else {
            toggler.classList.remove('variation-switcher-style-switcher--active');
          }
        });
      }

      // If no style variation matched or no cookie, set default button active
      if (!activeSet && DOM.resetButton) {
        DOM.resetButton.classList.add('variation-switcher-style-switcher--active');
      }
    }

    const init = () => {
      cacheDOM();
      eventListeners();
      setActiveClass(); // Add this line to set the active class on initialization
    }

    return { init };
  }

  const displayVariationSwitcherPopup = () => {
    const DOM = {}
    const body = document.body

    const handleVariationToggler = () => {
      DOM.variationSwitcherWrapper.classList.toggle('active')
    }

    const handleBodyClick = (event) => {
      if (!DOM.variationSwitcherWrapper.contains(event.target) && !DOM.variationToggler.contains(event.target)) {
        DOM.variationSwitcherWrapper.classList.remove('active');
      }
    }

    const cacheDOM = () => {
      DOM.variationToggler = document.querySelector('.variation-switcher-toggler')
      DOM.variationSwitcherWrapper = document.querySelector('.variation-switcher')
      DOM.variationSwitcherClose = document.querySelector('.variation-switcher-times')
    }

    const eventListeners = () => {
      DOM.variationToggler.addEventListener('click', handleVariationToggler)
      DOM.variationSwitcherClose.addEventListener('click', handleVariationToggler)
      body.addEventListener('click', handleBodyClick);
    }

    const init = () => {
      cacheDOM()
      eventListeners()
    }

    return { init }
  }

  document.addEventListener('DOMContentLoaded', () => {
    styleVariationToggle().init()
    displayVariationSwitcherPopup().init()
  })
})()

